import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import Styles from '../../styles/templates/template.module.css';
import { ToggleLabel, Card } from '@weezevent/nacre';
import TemplateList from './templateList';
import { TemplateItem } from './templateItem';
import { Trans } from 'react-i18next';
import ActiveMailTemplate from '../../models/activeMailTemplate';
import useAppContext from '../../context/useAppContext';
import Loading from '../../components/loading';

const TemplateSelector = React.forwardRef(({ values, onSelect, selectedTemplate, toggleLabel, showTemplatesCard, ruleKey }, ref) => {
    const [{ organization, partner }] = useAppContext();

    const [showTemplates, setShowTemplates] = React.useState(showTemplatesCard);
    const toggleTemplates = React.useCallback(() => setShowTemplates(showTemplates => !showTemplates), []);
    const [activeTemplate, loadingActiveTemplate, syncActiveTemplate] = ActiveMailTemplate.useApiModel({
        organizationId: organization.id,
        key: ruleKey,
        query: {
            organization_id: organization.pk,
            partner_id: partner ? partner.pk : null
        }
    });

    React.useImperativeHandle(ref, () => ({ syncActiveTemplate }), [syncActiveTemplate]);

    if (loadingActiveTemplate) {
        return <Loading />;
    }

    return (
        <Card style={{ borderRadius: '5px' }} ref={ref}>
            <Grid className={Styles['template-cards']}>
                <div className={Styles['template-cards-active-container']}>
                    <div className={Styles['template-cards-active']}>
                        <div className={Styles['template-cards-active-title']}>
                            <Trans i18nKey="ticket.mailing.active-template" />
                        </div>
                        <div className={Styles['template-cards-active-image']}>{activeTemplate && <TemplateItem template={activeTemplate} />}</div>
                    </div>
                    <ToggleLabel inlinePosition="right" label={toggleLabel} onChange={toggleTemplates} checked={showTemplates} />
                </div>
                {showTemplates && <TemplateList values={values} selectedTemplate={selectedTemplate} onSelect={onSelect} />}
            </Grid>
        </Card>
    );
});

TemplateSelector.propTypes = {
    values: PropTypes.array,
    onSelect: PropTypes.func.isRequired,
    selectedTemplate: PropTypes.number,
    toggleLabel: PropTypes.node.isRequired,
    showTemplatesCard: PropTypes.bool.isRequired
};

TemplateSelector.displayName = 'TemplateSelector';

export default TemplateSelector;
